import { get } from 'lodash';
import { callApi } from '../common/api';
import { API_END_POINTS } from '../config/api-endpoints';

const getListWithUserDetails = async () => {
  const headers = {
    'X-Cleartax-Product': 'EInvoice',
    // 'X-Cleartax-Auth-Token':
    //   '1.a242d79a-cecc-4420-b61e-58b5628cdd1f_f490174e6f474eb2526ed1737eb6cf50c80a2e86e97416bbd4d4a9c45d284c56',
  };
  const response = await callApi({
    method: 'GET',
    url: API_END_POINTS.SETTINGS.USER_DETAILS,
    headers,
  });
  return response.data;
};

export const getUserEmail = async () => {
  const userDetails = await getListWithUserDetails();
  let isMigratedToAuthz3 = false;
  if (userDetails) {
    if (userDetails.orgUnits) {
      if (userDetails.orgUnits.length <= 0) {
        isMigratedToAuthz3 = true;
      } else {
        const orgUnit = userDetails.orgUnits.filter((unit: any) => unit.level === 'ORGANISATION');
        const migrationStatus = get(orgUnit[0], 'metadata.authz3_migration', '2');
  
        if (!orgUnit) {
          isMigratedToAuthz3 = true;
        } else {
          isMigratedToAuthz3 = migrationStatus === '1';
        }
      }
    }
  }

  return {
    email: get(userDetails, 'username', 'User'),
    isMigratedToAuthz3,
  };
};
